import { User } from '@types'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import { getCasesSuccess, getCasesFailed, getNewCases, patchAnalystInfo } from './analystTrackSlice'
import { getAnalystNewCases, putCaseInfo } from '@http/analystService'
import { PayloadAction } from '@reduxjs/toolkit'

export function* getAnalystsNewCasesSaga() {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const cases: User[] = yield call(getAnalystNewCases, cocap, userId)
    yield put(getCasesSuccess(cases))
  } catch (e) {
    yield put(getCasesFailed(JSON.stringify(e)))
  }
}

export function* updateFilesAnalyst({ payload }: PayloadAction<Partial<User>>) {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const response: { message: string } = yield call(putCaseInfo, cocap, userId, payload)
    let cases = []
    if (response.message === 'success') {
      cases = yield call(getAnalystNewCases, cocap, userId)
    }
    yield put(getCasesSuccess(cases))
  } catch (e) {
    yield put(getCasesFailed(JSON.stringify(e)))
  }
}

export default function* commissionsSaga() {
  yield takeEvery(getNewCases.type, getAnalystsNewCasesSaga)
  yield takeEvery(patchAnalystInfo.type, updateFilesAnalyst)
}
